export default {
  init() {

    var $signatureHolder = jQuery(".logo-signature");
    var $breadcrumbsHolder = jQuery(".section-breadcrumbs");
    var windowWidth = jQuery(window).width();

    jQuery(window).on("resize", function(){
      windowWidth = jQuery(window).width();
    });

    jQuery(window).scroll(function(){

      if( windowWidth >= 1024 ){
        var scrollTopValue = jQuery(window).scrollTop();

          // Manage the signatures display on scrolling
          if( scrollTopValue > 200  && !$signatureHolder.hasClass('scrolledBy') ) {
            $signatureHolder.addClass('scrolledBy');
          } else if( scrollTopValue <= 200 ) {
            $signatureHolder.removeClass('scrolledBy');
          }

          // Manage the breadcrumbs display on scrolling
          if( scrollTopValue > 200  && !$breadcrumbsHolder.hasClass('scrolledBy') ) {
            $breadcrumbsHolder.addClass('scrolledBy');
          } else if( scrollTopValue <= 200 ) {
            $breadcrumbsHolder.removeClass('scrolledBy');
          }
      }

    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js